/**
 * * end of cart upsell block part
 */
document.addEventListener("DOMContentLoaded", function () {
  const amountFreeProduct = document.querySelector("[data-treshold-product]")
    ? document.querySelector("[data-treshold-product]").getAttribute("data-treshold-product")
    : null;

  var cartTotalEl = document.querySelector(".gb-totals-total-value");
  var cart_total = cartTotalEl ? (cartTotalEl.textContent || "").trim() : "";
  if (amountFreeProduct > 0 && show_progress_bar) {
    const hasPremiumKit = document.querySelector(".premium-attachment-kit") !== null;
    if (hasPremiumKit) {
      console.log("Premium kit detected - skipping auto free gift trigger");
      return;
    }
    setTimeout(function () {
      var el = document.querySelector(".gb-totals-total-value");
      var cart_total = el ? (el.textContent || "").trim() : "";
      if (cart_total >= amountFreeProduct) {
        if (document.querySelector(".cart-item.gb-find-remove-product")) {
          console.log("Free product already in cart");
        } else {
          console.log("Adding free product");
          var trigger = document.querySelector(".gb-free-product-trigger");
          if (trigger) trigger.click();
        }
      } else {
        console.log("Removing free product - under threshold");
        var removeBtn = document.querySelector(".gb-remove-product");
        if (removeBtn) removeBtn.click();
      }
    }, 3000);

    document.body.addEventListener("click", function (e) {
      if (!e.target.closest(".gb-sumbit-free")) return;
      setTimeout(function () {
        var el = document.querySelector(".gb-totals-total-value");
        var cart_total = el ? (el.textContent || "").trim() : "";
        if (cart_total >= amountFreeProduct) {
          if (!document.querySelector(".cart-item.gb-find-remove-product")) {
            var trigger = document.querySelector(".gb-free-product-trigger");
            if (trigger) trigger.click();
          }
        } else {
          var removeBtn = document.querySelector(".gb-remove-product");
          if (removeBtn) removeBtn.click();
        }
      }, 3000);
    });
  }

  document.body.addEventListener("click", async function (e) {
    var label = e.target.closest && e.target.closest(".gb-shipping-protection-button label.switch");
    if (!label) return;
    if (e.target.tagName === "INPUT") return;
    const curElem = document.querySelector(".gb-shipping-protection-button label.switch");
    const curInputElem = document.querySelector(".gb-shipping-protection-button label.switch input");
    const spinAnim = document.querySelector(".gb-shipping-protection-button .spin-animation");
    const checkElem = document.querySelector(".gb-shipping-protection-button .complete-check");
    const wasChecked = curElem && curElem.classList.contains("checked");

    if (!wasChecked) {
      if (!curElem || !curInputElem || !spinAnim || !checkElem) return;
      if (spinAnim.style.display === "block" || curInputElem.checked) return;
      const form = document.querySelector("form.shipping-protection-form");

      const formData = new FormData(form);
      if (!formData.get("id")) {
        console.error(
          "There is no shipping protection product selected. Please select the shipping product in the global theme settings",
        );
        return;
      }

      spinAnim.style.display = "block";

      try {
        const response = await fetch(routes.cart_add_url, {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (response.ok) {
          spinAnim.style.display = "none";

          checkElem.style.display = "block";
        }
      } catch (err) {
        console.error("error at shipping protection form submission", err);
      }
      fetch(routes.cart_url + "?view=drawer")
        .then((response) => response.text())
        .then((html) => {
          const cartDrawer = document.querySelector("#CartDrawer");
          const parsedCartHtml = parser.parseFromString(html, "text/html");
          const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
          if (cartDrawer && newCartDrawer) {
            updateCartDrawer(cartDrawer, newCartDrawer, true, () => {
              curElem.classList.remove("unchecked");
              curElem.classList.add("checked");
              curInputElem.checked = true;
            });
          }
        })
        .catch((_err) => {
          curElem.classList.remove("unchecked");
          curElem.classList.add("checked");
          curInputElem.checked = true;
        });
    } else {
      checkElem.style.display = "none";
      const cartDrawer = document.querySelector("#CartDrawer");
      const removeButton = cartDrawer.querySelector(`cart-remove-button[data-id="${shippingProductId}"]`);
      const shippingItemIndex = removeButton?.dataset.index;

      const removeCallback = () => {
        curElem.classList.remove("checked");
        curElem.classList.add("unchecked");
        curInputElem.checked = false;
      };

      const cartItems = cartDrawer.querySelector("cart-items") || cartDrawer.querySelector("cart-drawer-items");

      if (removeButton && shippingItemIndex && cartItems?.updateQuantity) {
        const event = new CustomEvent("remove-shipping-protection", {
          detail: null,
        });
        cartItems.updateQuantity(shippingItemIndex, 0, event, "", "", removeCallback);
      } else {
        fetch(routes.cart_change_url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ id: shippingProductId, quantity: 0 }),
        })
          .then(() => fetch(routes.cart_url + "?view=drawer"))
          .then((response) => response.text())
          .then((html) => {
            const cartDrawer = document.querySelector("#CartDrawer");
            const parsedCartHtml = parser.parseFromString(html, "text/html");
            const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
            if (cartDrawer && newCartDrawer) {
              updateCartDrawer(cartDrawer, newCartDrawer, true, removeCallback);
            } else {
              removeCallback();
            }
          })
          .catch(() => {
            removeCallback();
          });
      }
    }
  });

  document.body.addEventListener("change", function (e) {
    var select = e.target.closest && e.target.closest(".gb-change-variant_id");
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    var id_change = opt ? opt.getAttribute("data-variant-id") : null;
    if (!id_change) {
      console.error("No data-variant-id found on selected option");
      return;
    }
    var block = select.closest(".gb-get-main-freq-pro");
    var input = block ? block.querySelector(".product-variant-id") : null;
    if (input) input.value = id_change;
  });
});

document.addEventListener("change", function (e) {
  if (e.target.matches(".cart-drawer .gbfrequently-bought-with-main-whole .select__select")) {
    const parentBlock = e.target.closest(".gb-get-main-freq-pro");
    if (!parentBlock) {
      console.log("Error: Could not find parent block");
      return;
    }

    const allValues = Array.from(parentBlock.querySelectorAll(".select__select"))
      .map((sel) => sel.value)
      .join(" / ");

    const variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) {
      console.log("Error: Could not find variant selector");
      return;
    }

    const matchedOption = Array.from(variantSelect.options).find((option) => option.text.includes(allValues));

    const idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) {
      console.log("Error: Could not find id input field");
      return;
    }

    if (matchedOption) {
      console.log("Matched variant option value:", matchedOption.value);
      idInput.value = matchedOption.value;
      console.log("Set ID input value to:", idInput.value);
    } else {
      console.log("No matching variant found for:", allValues);
    }
  }
});

// Add validation for form submissions: require id when in single-variant mode; skip when form has items[] (bundles / premium kit)
document.addEventListener("submit", function (e) {
  if (typeof Elixir_ProductFormExists !== 'function' || !Elixir_ProductFormExists()) return;
  if (typeof Elixir_GetProductForm !== 'function' || Elixir_GetProductForm() !== e.target) return;
  if (typeof Elixir_GetProductFormVariantId !== 'function') return;
  if (typeof Elixir_ProductFormHasItemsInputs === 'function' && Elixir_ProductFormHasItemsInputs()) return;
  const variantId = Elixir_GetProductFormVariantId();
  if (!variantId) {
    console.log("Preventing submission - missing id parameter (single-product form has no variant id)");
    e.preventDefault();
    if (window.ThemeEditorToast && typeof window.ThemeEditorToast.show === 'function') {
      window.ThemeEditorToast.show('Add to cart failed: missing variant ID on product form.', { type: 'error', duration: 5000 });
    }
    return false;
  }
});

document.addEventListener("DOMContentLoaded", function () {
  function handleCartQuantityChange(e) {
    var cartItem = e.target.closest(".cart-item");
    if (!cartItem) return;
    var trigger =
      e.target.closest(".quantity__button") ||
      e.target.closest(".quantity__input") ||
      (e.target.matches && e.target.matches(".quantity__input") ? e.target : null);
    if (!trigger) return;
    var quantityInputWrap = trigger.closest(".quantity-input");
    var qtyInput = quantityInputWrap ? quantityInputWrap.querySelector(".quantity__input") : null;
    var variantId = qtyInput ? qtyInput.getAttribute("data-quantity-variant-id") : null;
    var form = trigger.closest("form");
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput && variantId) {
      console.log("Adding missing ID input to cart form");
      var newIdInput = document.createElement("input");
      newIdInput.type = "hidden";
      newIdInput.name = "id";
      newIdInput.value = variantId;
      form.appendChild(newIdInput);
    } else if (idInput && variantId) {
      idInput.value = variantId;
    }
  }
  document.addEventListener("click", handleCartQuantityChange);
  document.addEventListener("change", handleCartQuantityChange);
  document.addEventListener("input", handleCartQuantityChange);

  var checkoutBtn = document.getElementById("CartDrawer-Checkout");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function (e) {
      var form = document.getElementById("CartDrawer-Form");
      if (!form) return;
      var cartItems = form.querySelectorAll(".cart-item");
      if (cartItems.length === 0) {
        console.log("No items in cart, preventing checkout");
        e.preventDefault();
        return false;
      }
      console.log("Cart checkout with", cartItems.length, "items");
    });
  }

  document.addEventListener("keydown", function (e) {
    var input =
      (e.target.matches && e.target.matches(".quantity__input")
        ? e.target
        : e.target.closest && e.target.closest(".quantity__input")) || null;
    if (!input) return;
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      input.blur();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    var btn =
      e.target.closest(".gbfrequently-bought-with-main-whole button") ||
      e.target.closest(".gbfrequently-bought-with-main-whole .gb-sumbit-free") ||
      e.target.closest(".gb-free-product-trigger") ||
      e.target.closest(".gb-product-shipping-protection-product-tirgger") ||
      e.target.closest(".gb-product-sticky-add-to-cart-form");
    if (!btn) return;
    var parentBlock = btn.closest(".gb-get-main-freq-pro") || btn.closest("form");
    if (!parentBlock) {
      console.error("Could not find parent block for frequently bought product");
      return;
    }
    var productId = null;
    var idInput = parentBlock.querySelector('input[name="id"]');
    if (idInput && idInput.value) {
      productId = idInput.value;
    } else if (parentBlock.querySelector(".gb-change-variant_id")) {
      var select = parentBlock.querySelector(".gb-change-variant_id");
      var opt = select && select.options[select.selectedIndex];
      if (opt) {
        productId = opt.getAttribute("data-variant-id");
      }
    } else if (parentBlock.querySelector(".product-variant-id")) {
      var variantInput = parentBlock.querySelector(".product-variant-id");
      productId = variantInput ? variantInput.value : null;
    } else if (btn.getAttribute("data-variant-id")) {
      productId = btn.getAttribute("data-variant-id");
    }
    console.log("Frequently bought product add to cart - ID:", productId);
    if (btn.classList.contains("gb-free-product-trigger") && !show_progress_bar) return;
    if (!productId) {
      console.error("Missing product ID for frequently bought product");
      e.preventDefault();
      return false;
    }
    if (!idInput) {
      console.log("Adding missing ID input to frequently bought product form");
      var newIdInput = document.createElement("input");
      newIdInput.type = "hidden";
      newIdInput.name = "id";
      newIdInput.value = productId;
      parentBlock.appendChild(newIdInput);
    } else {
      idInput.value = productId;
    }
    var quantityInput = parentBlock.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      console.log("Adding default quantity input to frequently bought product form");
      var newQtyInput = document.createElement("input");
      newQtyInput.type = "hidden";
      newQtyInput.name = "quantity";
      newQtyInput.value = "1";
      parentBlock.appendChild(newQtyInput);
    } else if (!quantityInput.value || parseFloat(quantityInput.value, 10) < 1) {
      quantityInput.value = "1";
    }
  });
});

// Kaching showing Price(Compare Price) Text in ATC fix

const KachingApp = () => {
  const isProductPage = document.querySelector('.shopify-section.shop-product-section');
  if (!isProductPage) return;

  let buttonObserver = null;

  const createElement = (tag, cls, content) => {
    const el = document.createElement(tag);
    el.classList.add(...cls.split(' '));
    el.textContent = content;
    return el;
  };

  const updateAddToCartButton = (bundle) => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    if (!addToCartButton || !bundle) return;

    const buttonTextEl = addToCartButton.querySelector('.button-text');
    if (!buttonTextEl) return;

    const bundlePriceEl = bundle.querySelector('.kaching-bundles__bar-price');
    const bundleComparePriceEl = bundle.querySelector('.kaching-bundles__bar-full-price');

    if (bundlePriceEl) {
      const price = bundlePriceEl.textContent.trim();
      const comparePrice = bundleComparePriceEl ? bundleComparePriceEl.textContent.trim() : '';

      // Get the persistent text (e.g., "Buy Now")
      const persistentText = addToCartButton.getAttribute('data-persistent-text') || 'Buy Now';

      // Update button text with actual values
      if (comparePrice) {
        buttonTextEl.innerHTML = `${persistentText} - ${price}<span class="compare-price">(${comparePrice})</span>`;
      } else {
        buttonTextEl.innerHTML = `${persistentText} - ${price}`;
      }

      // Store current bundle reference for observer
      addToCartButton.dataset.currentBundlePrice = price;
      addToCartButton.dataset.currentBundleComparePrice = comparePrice || '';
    }
  };

  const forceUpdateButton = () => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    const buttonTextEl = addToCartButton?.querySelector('.button-text');
    
    if (!buttonTextEl) return;

    const price = addToCartButton.dataset.currentBundlePrice;
    const comparePrice = addToCartButton.dataset.currentBundleComparePrice;
    const persistentText = addToCartButton.getAttribute('data-persistent-text') || 'Buy Now';

    // Check if button shows placeholders
    if (buttonTextEl.textContent.includes('[price]') || buttonTextEl.textContent.includes('[comparePrice]')) {
      if (price) {
        if (comparePrice) {
          buttonTextEl.innerHTML = `${persistentText} - ${price}<span class="compare-price">(${comparePrice})</span>`;
        } else {
          buttonTextEl.innerHTML = `${persistentText} - ${price}`;
        }
      }
    }
  };

  const setupButtonObserver = () => {
    const addToCartButton = document.querySelector('.shop-add-to-cart-button');
    if (!addToCartButton) return;

    // Disconnect existing observer if any
    if (buttonObserver) {
      buttonObserver.disconnect();
    }

    // Create new observer to watch for button text changes
    buttonObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList' || mutation.type === 'characterData') {
          // Use setTimeout to let the other script finish, then override
          setTimeout(forceUpdateButton, 0);
        }
      });
    });

    // Observe the button and its children for any changes
    buttonObserver.observe(addToCartButton, {
      childList: true,
      subtree: true,
      characterData: true,
      characterDataOldValue: true
    });
  };

  const updatePriceBlock = (bundle) => {
    const priceBlock = document.querySelector('.shop-product-price-container');
    if (!priceBlock || !bundle) return;

    const priceEl = priceBlock.querySelector('.shop-product-price-block');
    const comparePriceEl = priceBlock.querySelector('.shop-compare-price');

    const bundlePriceEl = bundle.querySelector('.kaching-bundles__bar-price');
    const bundleComparePriceEl = bundle.querySelector('.kaching-bundles__bar-full-price');

    if (priceEl && bundlePriceEl) priceEl.textContent = bundlePriceEl.textContent;

    if (bundleComparePriceEl) {
      if (comparePriceEl) {
        comparePriceEl.textContent = bundleComparePriceEl.textContent;
      } else {
        priceBlock.appendChild(
          createElement('span', 'shop-compare-price', bundleComparePriceEl.textContent)
        );
      }
    }
  };

  const updateAllPrices = (bundle) => {
    updatePriceBlock(bundle);
    updateAddToCartButton(bundle);
    
    // Force update again after a short delay to override any competing scripts
    setTimeout(() => forceUpdateButton(), 50);
    setTimeout(() => forceUpdateButton(), 200);
  };

  const initApp = (app) => {
    const applyFirstCheckedBundle = () => {
      const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
      if (selectedBundle) {
        updateAllPrices(selectedBundle);
      }
    };

    const initAppFunctions = () => {
      const interval = setInterval(() => {
        const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
        if (selectedBundle) {
          clearInterval(interval);
          updateAllPrices(selectedBundle);
          setupButtonObserver();
        }
      }, 300);
    };

    app.addEventListener('change', () => {
      const selectedBundle = app.querySelector('.kaching-bundles__bar:has(input:checked)');
      updateAllPrices(selectedBundle);
    });

    applyFirstCheckedBundle();
    initAppFunctions();
  };

  const interval = setInterval(() => {
    const app = document.querySelector('kaching-bundle');
    if (app) {
      clearInterval(interval);
      initApp(app);
    }
  }, 300);
};

window.addEventListener('DOMContentLoaded', KachingApp);

/* === GARANZIA ESTESA AUTO-ADD (aggiunta di default, rimovibile, ri-aggiungibile) === */
(function(){var LG=(document.documentElement.lang||''),WID=LG.indexOf('pl')===0?56472031101313:LG.indexOf('nl')===0?56469622784385:(LG.indexOf('es')===0?56436255359361:56320796524929),K_REM='wty_removed',K_HAD='wty_had',K_LOCK='wty_lock',busy=false,of=window.fetch.bind(window);function ss(k,v){try{if(v===undefined)return sessionStorage.getItem(k);if(v===null)sessionStorage.removeItem(k);else sessionStorage.setItem(k,v);}catch(e){}return null;}function onCartPage(){return /\/cart\/?$/.test(location.pathname);}async function check(){if(busy)return;busy=true;try{var cart=await of('/cart.js',{cache:'no-store'}).then(function(r){return r.json();});var has=cart.items.some(function(i){return i.variant_id===WID;});var others=cart.items.filter(function(i){return i.variant_id!==WID;});var main=others.filter(function(i){return i.final_line_price>0;});if(!main.length){ss(K_REM,null);ss(K_HAD,null);if(has){var w=cart.items.find(function(i){return i.variant_id===WID;});await of('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:w.key,quantity:0})});if(onCartPage()){location.reload();}else{try{var rs=await of('/?sections=cart-drawer,cart-icon-bubble').then(function(x){return x.json();});var DP=new DOMParser(),cdr=document.querySelector('cart-drawer'),ndr=rs['cart-drawer']?DP.parseFromString(rs['cart-drawer'],'text/html').querySelector('cart-drawer'):null;if(cdr&&ndr){cdr.innerHTML=ndr.innerHTML;if(cart.items.length<=1)cdr.classList.add('is-empty');}var bb=document.getElementById('cart-icon-bubble');if(bb&&rs['cart-icon-bubble']){var sb=DP.parseFromString(rs['cart-icon-bubble'],'text/html').querySelector('.shopify-section');if(sb)bb.innerHTML=sb.innerHTML;}}catch(e2){}}}return;}if(has){ss(K_HAD,'1');return;}if(ss(K_HAD)==='1'){ss(K_HAD,null);ss(K_REM,'1');return;}if(ss(K_REM)==='1')return;var lock=+(ss(K_LOCK)||0);if(Date.now()-lock<8000)return;ss(K_LOCK,String(Date.now()));var inp=document.querySelector('form.upsell-form input[name="id"][value="'+WID+'"]');var btn=inp?inp.closest('form').querySelector('button[name="upsell-add"]'):null;if(btn&&!onCartPage()){btn.click();}else{await of('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:WID,quantity:1}]})});ss(K_HAD,'1');if(onCartPage())location.reload();}}catch(e){console.warn('wty',e);}finally{busy=false;}}function later(){setTimeout(check,500);}window.fetch=function(){var a=arguments,p=of.apply(window,a);try{var u=typeof a[0]==='string'?a[0]:((a[0]&&a[0].url)||'');if(/\/cart\/(add|change|update|clear)/.test(u))p.then(later,function(){});}catch(e){}return p;};var xo=XMLHttpRequest.prototype.open;XMLHttpRequest.prototype.open=function(m,u){try{if(/\/cart\/(add|change|update|clear)/.test(String(u)))this.addEventListener('load',later);}catch(e){}return xo.apply(this,arguments);};if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',later);else later();})();
/* === FINE GARANZIA ESTESA AUTO-ADD === */

/* === APRI CART DRAWER DOPO "ACQUISTA ORA" DI PAGEFLY (invece della pagina /cart) === */
(function(){var pend=0,t=null;document.addEventListener('click',function(e){var b=e.target&&e.target.closest?e.target.closest('[data-pf-type^="ProductATC"]'):null;if(b)pend=Date.now();},true);function isAdd(u){return /\/cart\/add/.test(String(u));}function trig(){if(!pend||Date.now()-pend>15000)return;clearTimeout(t);t=setTimeout(refreshOpen,1200);}async function refreshOpen(){pend=0;try{var r=await fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'?sections=cart-drawer,cart-icon-bubble').then(function(x){return x.json();});var P=new DOMParser();var cd=document.querySelector('cart-drawer');var nd=r['cart-drawer']?P.parseFromString(r['cart-drawer'],'text/html').querySelector('cart-drawer'):null;if(cd&&nd){cd.innerHTML=nd.innerHTML;cd.classList.remove('is-empty');}var bub=document.getElementById('cart-icon-bubble');if(bub&&r['cart-icon-bubble']){var s=P.parseFromString(r['cart-icon-bubble'],'text/html').querySelector('.shopify-section');if(s)bub.innerHTML=s.innerHTML;}if(cd&&typeof cd.open==='function')cd.open();}catch(e){console.warn('drawer',e);}}var f0=window.fetch;window.fetch=function(){var a=arguments,p=f0.apply(window,a);try{var u=typeof a[0]==='string'?a[0]:((a[0]&&a[0].url)||'');if(isAdd(u))p.then(trig,function(){});}catch(e){}return p;};var xo=XMLHttpRequest.prototype.open;XMLHttpRequest.prototype.open=function(m,u){try{if(isAdd(u))this.addEventListener('load',trig);}catch(e){}return xo.apply(this,arguments);};})();
/* === FINE APRI CART DRAWER === */

/* === CONTINUA LO SHOPPING -> HOME PAGE === */
(function(){var SEL='.cart-drawer__empty-content a, .drawer__inner-empty a, .cart__warnings a, .title-wrapper-with-link a';function fix(){document.querySelectorAll(SEL).forEach(function(a){if(/\/collections\/all/.test(a.getAttribute('href')||''))a.setAttribute('href','/');});}document.addEventListener('click',function(e){var a=e.target&&e.target.closest?e.target.closest(SEL):null;if(a&&/\/collections\/all/.test(a.getAttribute('href')||'')){e.preventDefault();window.location.href='/';}},true);if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',fix);else fix();new MutationObserver(fix).observe(document.documentElement,{childList:true,subtree:true});})();
/* === FINE CONTINUA LO SHOPPING === */

/* === GARANZIA CON TOGGLE NEL CART DRAWER (attiva di default, disattivabile, riattivabile) === */
(function(){var LG=(document.documentElement.lang||''),PL=LG.indexOf('pl')===0,NL=LG.indexOf('nl')===0,ES=LG.indexOf('es')===0,WID=PL?56472031101313:NL?56469622784385:(ES?56436255359361:56320796524929),H=PL?'przedluzona-gwarancja-na-4-lata-pelna-ochrona':NL?'4-jaar-verlengde-garantie-volledige-bescherming':(ES?'dd':'garanzia-estesa-2-anni-protezione-totale'),DESC=PL?'Obejmuje każde uszkodzenie, także przypadkowe, przez 4 lata. Gwarantowany zwrot pieniędzy lub wymiana.':NL?'Dekt elke schade, ook door ongelukken, gedurende 4 jaar. Terugbetaling of vervanging gegarandeerd.':ES?'Cubre cualquier daño, incluso accidental, durante 4 años. Reembolso o sustitución garantizados.':'Copre qualsiasi danno, anche accidentale, per 4 anni. Rimborso o sostituzione garantiti.',prod=null,busy=false,t=null;function money(c){if(window.Shopify&&Shopify.currency&&Shopify.currency.active==='PLN')return (c/100).toFixed(2).replace('.',',')+' zł';try{if(window.Shopify&&Shopify.formatMoney)return Shopify.formatMoney(c,(window.theme&&theme.moneyFormat)||'€{{amount_with_comma_separator}}');}catch(e){}return '€'+(c/100).toFixed(2).replace('.',',');}async function getProd(){if(prod)return prod;try{prod=await fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'products/'+H+'.js').then(function(r){return r.json();});}catch(e){prod={};}return prod;}async function refresh(){try{var r=await fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'?sections=cart-drawer,cart-icon-bubble').then(function(x){return x.json();});var P=new DOMParser(),cd=document.querySelector('cart-drawer'),nd=r['cart-drawer']?P.parseFromString(r['cart-drawer'],'text/html').querySelector('cart-drawer'):null;if(cd&&nd){cd.innerHTML=nd.innerHTML;}var bb=document.getElementById('cart-icon-bubble');if(bb&&r['cart-icon-bubble']){var s=P.parseFromString(r['cart-icon-bubble'],'text/html').querySelector('.shopify-section');if(s)bb.innerHTML=s.innerHTML;}}catch(e){}}async function sync(){if(busy)return;var cd=document.querySelector('cart-drawer');if(!cd||!cd.querySelector('.drawer__footer'))return;var cart=await fetch('/cart.js',{cache:'no-store'}).then(function(r){return r.json();});var has=cart.items.some(function(i){return i.variant_id===WID;});var main=cart.items.filter(function(i){return i.variant_id!==WID&&i.final_line_price>0;});var ft=cd.querySelector('.drawer__footer');var box=document.getElementById('wty-box');if(!main.length||!ft){if(box)box.remove();return;}if(!box||!ft.contains(box)){if(box)box.remove();var p=await getProd();var v=(p.variants||[]).find(function(x){return x.id===WID;})||{};var img=p.featured_image||'';box=document.createElement('div');box.id='wty-box';box.className='wty-box';box.innerHTML=(img?'<img src="'+img+'" alt="" width="52" height="52">':'')+'<div class="wty-txt"><div class="wty-title">'+(PL?'Przedłużona gwarancja 4 lata':NL?'Verlengde garantie 4 jaar':ES?'Garantía Extendida 4 Años':'Garanzia Estesa 4 Anni')+' – '+money(v.price||799)+'</div><div class="wty-desc">'+DESC+'</div></div><label class="wty-switch"><input type="checkbox" aria-label="Garanzia Estesa 4 Anni"><span class="wty-slider"></span></label>';ft=cd.querySelector('.drawer__footer');if(!ft)return;ft.insertBefore(box,ft.firstChild);box.querySelector('input').addEventListener('change',onToggle);}var inp=box.querySelector('input');inp.checked=has;inp.disabled=false;}async function onToggle(e){var inp=e.target;busy=true;inp.disabled=true;try{if(inp.checked){await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:WID,quantity:1}]})});}else{var cart=await fetch('/cart.js',{cache:'no-store'}).then(function(r){return r.json();});var w=cart.items.find(function(i){return i.variant_id===WID;});if(w)await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:w.key,quantity:0})});}await refresh();}catch(err){console.warn('wty toggle',err);}busy=false;sync();}function later(){clearTimeout(t);t=setTimeout(sync,250);}var f1=window.fetch;window.fetch=function(){var a=arguments,p=f1.apply(window,a);try{var u=typeof a[0]==='string'?a[0]:((a[0]&&a[0].url)||'');if(/\/cart\/(add|change|update|clear)/.test(u))p.then(function(){setTimeout(later,600);},function(){});}catch(e){}return p;};var xo1=XMLHttpRequest.prototype.open;XMLHttpRequest.prototype.open=function(m,u){try{if(/\/cart\/(add|change|update|clear)/.test(String(u)))this.addEventListener('load',function(){setTimeout(later,600);});}catch(e){}return xo1.apply(this,arguments);};function watch(){var cd=document.querySelector('cart-drawer');if(!cd){setTimeout(watch,500);return;}new MutationObserver(function(){var b=document.getElementById('wty-box');if(!b||!cd.contains(b))later();}).observe(cd,{childList:true,subtree:true});later();}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watch);else watch();})();
/* === FINE GARANZIA CON TOGGLE === */

/* === PAGINA CARRELLO /cart: GARANZIA CON TOGGLE + FIX TESTO SCONTI === */
(function(){if(!/\/cart\/?$/.test(location.pathname))return;var LG=(document.documentElement.lang||''),PL=LG.indexOf('pl')===0,NL=LG.indexOf('nl')===0,ES=LG.indexOf('es')===0,WID=PL?56472031101313:NL?56469622784385:(ES?56436255359361:56320796524929),H=PL?'przedluzona-gwarancja-na-4-lata-pelna-ochrona':NL?'4-jaar-verlengde-garantie-volledige-bescherming':(ES?'dd':'garanzia-estesa-2-anni-protezione-totale'),DESC=PL?'Obejmuje każde uszkodzenie, także przypadkowe, przez 4 lata. Gwarantowany zwrot pieniędzy lub wymiana.':NL?'Dekt elke schade, ook door ongelukken, gedurende 4 jaar. Terugbetaling of vervanging gegarandeerd.':ES?'Cubre cualquier daño, incluso accidental, durante 4 años. Reembolso o sustitución garantizados.':'Copre qualsiasi danno, anche accidentale, per 4 anni. Rimborso o sostituzione garantiti.',prod=null,run=false;function money(c){if(window.Shopify&&Shopify.currency&&Shopify.currency.active==='PLN')return (c/100).toFixed(2).replace('.',',')+' zł';try{if(window.Shopify&&Shopify.formatMoney)return Shopify.formatMoney(c,(window.theme&&theme.moneyFormat)||'€{{amount_with_comma_separator}}');}catch(e){}return '€'+(c/100).toFixed(2).replace('.',',');}function fixTxt(){document.querySelectorAll('#main-cart-footer span').forEach(function(s){if(/^Translation missing/i.test(s.textContent.trim()))s.textContent=PL?'Zastosowane rabaty':NL?'Toegepaste kortingen':ES?'Descuentos aplicados':'Sconti applicati';});}async function build(){if(run)return;run=true;try{fixTxt();var blk=document.querySelector('#main-cart-footer .cart__blocks');if(!blk)return;var cart=await fetch('/cart.js',{cache:'no-store'}).then(function(r){return r.json();});var has=cart.items.some(function(i){return i.variant_id===WID;});var main=cart.items.filter(function(i){return i.variant_id!==WID&&i.final_line_price>0;});var box=document.getElementById('wty-box-page');if(!main.length){if(box)box.remove();return;}if(!box){if(!prod){try{prod=await fetch(((window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/')+'products/'+H+'.js').then(function(r){return r.json();});}catch(e){prod={};}}var v=(prod.variants||[]).find(function(x){return x.id===WID;})||{};var img=prod.featured_image||'';box=document.createElement('div');box.id='wty-box-page';box.className='wty-box wty-box-page';box.innerHTML=(img?'<img src="'+img+'" alt="" width="52" height="52">':'')+'<div class="wty-txt"><div class="wty-title">'+(PL?'Przedłużona gwarancja 4 lata':NL?'Verlengde garantie 4 jaar':ES?'Garantía Extendida 4 Años':'Garanzia Estesa 4 Anni')+' – '+money(v.price||799)+'</div><div class="wty-desc">'+DESC+'</div></div><label class="wty-switch"><input type="checkbox" aria-label="Garanzia Estesa 4 Anni"><span class="wty-slider"></span></label>';blk.insertBefore(box,blk.firstChild);box.querySelector('input').addEventListener('change',async function(e){var inp=e.target;inp.disabled=true;try{if(inp.checked){await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:WID,quantity:1}]})});}else{var c2=await fetch('/cart.js',{cache:'no-store'}).then(function(r){return r.json();});var w=c2.items.find(function(i){return i.variant_id===WID;});if(w)await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:w.key,quantity:0})});}}catch(err){}location.reload();});}box.querySelector('input').checked=has;}finally{run=false;}}function start(){build();var f=document.getElementById('main-cart-footer');if(f)new MutationObserver(function(){fixTxt();if(!document.getElementById('wty-box-page'))build();}).observe(f,{childList:true,subtree:true});}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();})();
/* === FINE PAGINA CARRELLO === */